var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 304,
    viewBox: "0 0 457 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_261_886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.478 258.711H99.654V295.6H82.1974V258.711H4.13672V242.791L80.331 134.209H99.654V242.132H123.478V258.711ZM82.1974 242.132V188.775C82.1974 178.308 82.5634 166.487 83.2953 153.312H82.417C78.9037 160.339 75.61 166.158 72.5359 170.769L22.3619 242.132H82.1974Z",
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 258.711H429.176V295.6H411.719V258.711H333.658V242.791L409.852 134.209H429.176V242.132H453V258.711ZM411.719 242.132V188.775C411.719 178.308 412.085 166.487 412.817 153.312H411.938C408.425 160.339 405.132 166.158 402.057 170.769L351.883 242.132H411.719Z",
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.469,
    y: 132.778,
    width: 223.881,
    height: 49.4282,
    rx: 24.7141,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.291,
    cy: 157.977,
    rx: 18.4144,
    ry: 10.661,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.528,
    cy: 157.977,
    rx: 18.4144,
    ry: 10.661,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.16 86.2571C129.16 38.6186 167.779 0 215.417 0H247.4C295.039 0 333.657 38.6186 333.657 86.2571V86.2571H129.16V86.2571Z",
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.16,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.285,
    y: 88.1954,
    width: 16.7137,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.873,
    y: 88.1954,
    width: 16.7137,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.98,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.105,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.23,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.57,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.695,
    y: 88.1954,
    width: 16.7137,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.82,
    y: 88.1954,
    width: 16.7137,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.943,
    y: 88.1954,
    width: 16.7137,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.393,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "#0682FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.516,
    y: 88.1954,
    width: 15.7306,
    height: 36.8289,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.182 191.413C317.182 239.319 278.346 278.155 230.44 278.155V278.155C182.534 278.155 143.698 239.319 143.698 191.413L143.698 189.959L317.182 189.959L317.182 191.413Z",
    fill: "#EDAF74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.442,
    cy: 226.304,
    rx: 22.7758,
    ry: 13.0581,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_261_886",
    x: 0.136719,
    y: 0,
    width: 456.863,
    height: 303.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_886",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e62ee4fe6ee754985a427ab8660277e0.svg";
export { ForwardRef as ReactComponent };